import { render, staticRenderFns } from "./ListScFromKalibrcompany.vue?vue&type=template&id=68210300&scoped=true&"
import script from "./ListScFromKalibrcompany.vue?vue&type=script&lang=js&"
export * from "./ListScFromKalibrcompany.vue?vue&type=script&lang=js&"
import style0 from "./ListScFromKalibrcompany.vue?vue&type=style&index=0&id=68210300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68210300",
  null
  
)

export default component.exports